import { render, staticRenderFns } from "./fillblanks.vue?vue&type=template&id=6c4067fe&scoped=true&lang=html&"
import script from "./fillblanks.vue?vue&type=script&lang=js&"
export * from "./fillblanks.vue?vue&type=script&lang=js&"
import style0 from "./fillblanks.vue?vue&type=style&index=0&id=6c4067fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4067fe",
  null
  
)

export default component.exports